import { defineStore } from "pinia";

export const useEvaluationFileStore = defineStore('evaluationFile', {
    state: () => ({
        evaluationFile: {},
        evaluationFiles: [],
        evaluationListing: [],
    }),
    actions: {
        setEvaluationFile(evaluationFile) {
            this.evaluationFile = evaluationFile
        },
        setEvaluationFiles(evaluationFiles) {
            this.evaluationFiles = evaluationFiles
        },
        setEvaluationListing(evaluationListing) {
            this.evaluationListing = evaluationListing
        },
        addEvaluationFile(evaluationFile) {
            this.evaluationFiles.unshift(evaluationFile)
        },
        updateEvaluationFile(evaluationFile) {
            let index = this.evaluationFiles.findIndex(cl => cl.id === evaluationFile.id)
            this.evaluationFiles.splice(index, 1, evaluationFile)
        },
        deleteEvaluationFile(evaluationFile) {
            let index = this.evaluationFiles.findIndex(cl => cl.id === evaluationFile.id)
            this.evaluationFiles.splice(index, 1)
        },
    },
});